import { Action } from '@ngrx/store';

export const GET_CONTEXT_LIST = '[Context] Get Context List';
export const GET_CONTEXT_LIST_SUCCESS = '[Context] Get Context List Success';
export const GET_CONTEXT_LIST_FAIL = '[Context] Get Context List Fail';
export const SET_SYSTEM_CONTEXT = '[Context] Set System Context';
export const SET_INSTITUTION_CONTEXT = '[Context] Set Institution Context';
export const SAVE_CONTEXT = '[Context] Save Context';
export const SAVE_CONTEXT_SUCCESS = '[Context] Save Context Success';
export const SAVE_CONTEXT_FAIL = '[Context] Save Context Fail';
export const RESET_SAVE_STATUS = '[Context] Reset Save Status';

export class GetContextList implements Action {
  readonly type = GET_CONTEXT_LIST;
  constructor(
    public payload: { systemId?: number; institutionId?: number } = null,
  ) {}
}

export class GetContextListSuccess implements Action {
  readonly type = GET_CONTEXT_LIST_SUCCESS;
  constructor(public payload: any = null) {}
}

export class GetContextListFail implements Action {
  readonly type = GET_CONTEXT_LIST_FAIL;
  constructor(public payload: any = null) {}
}

export class SetSystemContext implements Action {
  readonly type = SET_SYSTEM_CONTEXT;
  constructor(public payload: any = null) {}
}

export class SetInstitutionContext implements Action {
  readonly type = SET_INSTITUTION_CONTEXT;
  constructor(public payload: any = null) {}
}

export class SaveContext implements Action {
  readonly type = SAVE_CONTEXT;
  constructor(
    public payload: {institutionId?: number, systemId?: number} = null
  ){}
}

export class SaveContextSuccess implements Action {
  readonly type = SAVE_CONTEXT_SUCCESS;
  constructor(public payload: any = null) {}
}

export class SaveContextFail implements Action {
  readonly type = SAVE_CONTEXT_FAIL;
  constructor(public payload: any = null) {}
}

export class ResetSaveStatus implements Action {
  readonly type = RESET_SAVE_STATUS;
  constructor(){}
}

export type ContextActions =
  | GetContextList
  | GetContextListSuccess
  | GetContextListFail
  | SetSystemContext
  | SetInstitutionContext
  | SaveContext
  | SaveContextSuccess
  | SaveContextFail
  | ResetSaveStatus;
